import CryptoSettings from './CryptoSettings';

const DialogCryptoSettings = () => (
	<div className='dialog-crypto-settings bg-primary-500'>
		<CryptoSettings isModal />
	</div>
);

export default DialogCryptoSettings;
